import { StorageTankOutlineIcon } from './StorageTankOutlineIcon';

/**
 * author: Google
 * id 6140C9BE-C66B-4ADC-957F-74A59541EA1A
 * name storage-tank-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/storage-tank-outline.svg
 * tags
 */
export const GasTankOutlineIcon = StorageTankOutlineIcon;
export default GasTankOutlineIcon